import React, { useEffect, useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import './Consultation.css';
import SEO from '../../components/SEO';

const Consultation = () => {
  const [value, onChange] = useState(new Date());
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Book a Free Consultation with Data Transformation Experts - CLoudPlexo"
        description="Schedule a free consultation with CloudPlexo's data transformation experts. Discuss your data optimization and AI strategies"
        keywords="Data Transformation Free Consultation, Consultation Booking, Expert Meeting Request, Data Strategy Discussion"
      />
      <div className="download-canvas">
        <section className="consult-nav">
          <h2>Book a free consultation</h2>
        </section>

        <section className="consult-service">
          <div className="consult-calendar">
            <h3>Service Info</h3>
            <h4>Capacity: 1 Duration 1h</h4>
            <p>Pick a date & time</p>

            <div>
              <DateTimePicker
                onChange={onChange}
                value={value}
              />
            </div>
          </div>

          <div className="consult-form">
            <h3>Schedule Free Consultation</h3>
            <h4>
              Employee: cloudplexo <br />
              Date: January 10, 2023 <br /> Local Time: 9:30 am
            </h4>

            <form>
              <label htmlFor="name">
                Full Name
                <input
                  type="text"
                  name="name"
                />
              </label>

              <label htmlFor="email">
                Email
                <input
                  type="email"
                  name="email"
                />
              </label>

              <label htmlFor="number">
                Phone Number
                <input
                  type="text"
                  name="number"
                />
              </label>

              <label htmlFor="company">
                Company
                <input
                  type="text"
                  name="company"
                />
              </label>

              <label htmlFor="employee">
                Number of company employees
                <input
                  type="text"
                  name="employee"
                />
              </label>

              <label htmlFor="country">
                Country
                <input
                  type="text"
                  name="country"
                />
              </label>

              <button className="left">Cancel</button>
              <button className="right">Submit</button>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};

export default Consultation;
